import Vue from 'vue'
import Router from 'vue-router'

import login from '@/Modules/Login/router'
import ChangePassword from '@/Modules/ChangePassword/router'
import DepositList from '@/Modules/DepositList/router'
import LoanList from '@/Modules/LoanList/router'

import store from './store';
import global from '@/components/rbconstants';
import error_page from '@/Modules/ErrorPage/router'



Vue.use(Router)


var allRoutes = [];
allRoutes = allRoutes.concat(login).concat(ChangePassword).concat(DepositList).concat(LoanList).concat(error_page)
const routes = allRoutes

const router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  var page_tile="";
  if(to.meta.title) {
    page_tile = to.meta.title;
  }
  store.state.router_loading_show = true;
  document.title = page_tile+' - '+global.app_name;
  
  var check_token = true;
  
  if(to.path == '/' || to.path == '/logout' || to.path == '/forgot-password'|| to.path == '/forgot-password/update') {
    check_token = false;
  }
  
  
  if(check_token) {
  
    if(localStorage.getItem('token') == "undefined" || localStorage.getItem('token')  == '' || localStorage.getItem('token')  == null) {
     // router.push('/logout')
    }
    
  }
  
  next()
})

router.afterEach((to, from, next) => {
  store.state.router_loading_show = false;
   
})



export default(router);


// https://demos.creative-tim.com/vuetify-material-dashboard/documentation/component-docs/buttons.html#sizes